import { ApiProperty, ApiPropertyOptional } from '@nestjs/swagger'
import { IsEnum, IsNotEmpty, IsOptional, IsString, Length } from 'class-validator'
import { IWifiSettings, IQuickAction, MessageType, ICustomerAppSettings } from '@backend/domain'

export class WifiSettings implements IWifiSettings {
	@ApiProperty({ type: String })
	@IsNotEmpty()
	@IsString()
	ssid: string

	@ApiProperty({ type: String, format: 'password' })
	@IsNotEmpty()
	@IsString()
	password: string
}

export class QuickAction implements IQuickAction {
	@ApiProperty({ type: String, minLength: 2, maxLength: 60 })
	@IsNotEmpty()
	@IsString()
	@Length(2, 60)
	headline: string

	@ApiProperty({ type: String, minLength: 2, maxLength: 150 })
	@IsNotEmpty()
	@IsString()
	@Length(2, 150)
	description: string

	@ApiProperty({ type: String, minLength: 2, maxLength: 150 })
	@IsNotEmpty()
	@IsString()
	@Length(2, 150)
	ackMessage: string

	@ApiProperty({ type: String })
	@IsNotEmpty()
	@IsString()
	iconUrl: string

	@ApiProperty({ enum: MessageType })
	@IsNotEmpty()
	@IsEnum(MessageType)
	messageType: MessageType

	@ApiProperty({ type: String, minLength: 2, maxLength: 150 })
	@IsNotEmpty()
	@IsString()
	@Length(2, 150)
	response: string
}

export class CustomerAppSettings implements ICustomerAppSettings {
	@ApiProperty({ type: String, minLength: 2, maxLength: 60 })
	@IsNotEmpty()
	@IsString()
	@Length(2, 60)
	displayName: string

	@ApiPropertyOptional({ type: String })
	@IsOptional()
	@IsString()
	bannerUrl?: string

	@ApiPropertyOptional({ type: String })
	@IsOptional()
	@IsString()
	logoUrl?: string

	@ApiPropertyOptional({ type: WifiSettings })
	@IsOptional()
	wifi?: WifiSettings

	@ApiPropertyOptional({ type: String })
	@IsOptional()
	reviewUrl?: string

	@ApiPropertyOptional({ type: QuickAction, isArray: true })
	@IsOptional()
	quickActions?: QuickAction[]
}
